import * as React from 'react'

function SvgCaseInstructionUnchecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m29 12.414-2.293 2.293-1.414-1.414L27.586 11l-2.293-2.293 1.414-1.414L29 9.586l2.293-2.293 1.414 1.414L30.414 11l2.293 2.293-1.414 1.414L29 12.414Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.01 12h2.045a8.95 8.95 0 0 0 .457 2H16v16h6a2 2 0 0 0 2-2v-9.516a8.964 8.964 0 0 0 2 1.003V26h.2c.857 0 1.439-.001 1.89-.038.438-.036.662-.1.818-.18a2 2 0 0 0 .874-.874c.08-.157.145-.38.18-.82.037-.45.038-1.032.038-1.888v-2.255a8.948 8.948 0 0 0 2-.457v2.753c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H26a4 4 0 0 1-4 4H11a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h5.008c.013-.392.046-.728.128-1.036a4 4 0 0 1 2.829-2.828c.433-.116.924-.134 1.547-.136a8.947 8.947 0 0 0-.458 2.008c-.292.009-.445.026-.571.06a2 2 0 0 0-1.415 1.414c-.032.119-.049.26-.058.518ZM12 14v16h2V14h-2Z"
      />
    </svg>
  )
}

export default SvgCaseInstructionUnchecked
